import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { categoriesActions } from "../../../../redux/actions/categories";
import * as actions from "../../../../redux/modules/actions";
import ViewCategories from "./view";
import { alertsActions } from "../../../../redux/actions/alertsActions";

const mapStateToProps = state => {
  return {
    catList: state.categoryReducer.views,
    catStatus: state.categoryReducer.status,
    deleteStatus: state.categoryReducer.delete,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...categoriesActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCategories);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/subcategories/index.js